<template>
  <div id="app">

    <div class="img-overlay"></div>
    <video class="video" src="./assets/triangle.mp4" autoplay="autoplay" loop="loop" muted ></video>
    <img class="logo" src="./assets/logo2-negative.svg" alt="Nachtschicht Logo">

    <div style="display: flex">
      <div class="bubbleanim" v-if="isTime || develop">
        <li v-for="post of posts" :key="post.id" @click="deleteItem()" v-bind:class="{ invisible: post.dummy }"> 
          <div class="text-bubble" v-bind:class="{left: post.positionLeft}">
              <!-- <div v-bind:class="{ userright: post.positionLeft , userleft: post.positionLeft == false }" class="inside">
                <p class="firstElement" v-if="post.name != null">{{post.name}}</p>
                <p class="firstElement" v-if="post.name == null">Anonym</p>
              </div> -->
            <p class="username" :class="{'user-bubble-right': post.positionLeft == true, 'user-bubble-left': post.positionLeft == false}" v-if="post.name != null">{{post.name}}</p>
            <p :class="{'user-bubble-right': post.positionLeft == true, 'user-bubble-left': post.positionLeft == false}"  v-if="post.name == null">Anonym</p>
            <h2>{{post.message}}</h2>
            <p class="postTime">{{post.created_at}}</p>
            <div class="spacer"></div>

              

          </div>
          <!-- <div v-if="post.positionLeft == false" class="username-bubble-wrapper-right">
            <div class="username-bubble">
              <p class="firstElement" v-if="post.name != null">{{post.name}}</p>
              <p class="firstElement" v-if="post.name == null">Anonym</p>
            </div>
          </div> -->
        </li>
      </div>
    </div>

    <div class="qr-code-wrapper" v-if="isTime || develop">
      <p class="white" style="max-width: 150px; margin: 0; margin-bottom: 1rem;">Du willst mitmachen? QR-Code scannen und loslegen!</p>
      <img class="qr-code" src="./assets/qrcode.jpeg">
    </div>
    <!-- <div v-if="develop" style="position: absolute; bottom: 1rem; left: 1rem; color: red; font-weight: bold;">
      <h1>ACHTUNG DEV-MODUS!!!</h1>
    </div> -->
  </div>
</template>

<script>

import axios from 'axios';

export default {
  name: 'app',
  data() {
    return {
      develop: true,
      posts: [],
      showcase: [],
      carousel: 0,
      dummy: true,
      isTime: false,
      messageRate: 5
    };
  },
  created(){
    this.getDataMother() //starting data pull timer
    this.killPost()  // starting the rotation/deletion
    this.callAxios() //initial data pull
    this.calculateTime() //Check if time is ready
  },
  methods: {
    calculateTime(){
      // timer for updating
      let self = this;
      let seconds = 0;

      //Initial Timecheck
      var objDate = new Date();
      var hours = objDate.getHours();
      var day = objDate.getDay();
      if(hours < 6 || hours > 17 && day == 5 || day == 6){
          self.isTime = true;
      }else{
          self.isTime = false;
      }

      function getTime() {
          seconds++; 
          if (seconds === 60) {
            var objDate = new Date();
            var hours = objDate.getHours();
            var day = objDate.getDay();
            if(hours < 6 || hours > 17 && day == 5 || day == 6){
                self.isTime = true;
            }else{
                self.isTime = false;
            }
            seconds = 0; //reset timer   
          }
        }
        setInterval(getTime, 1000); 
    },
    getDataMother(){
    let self = this
    let seconds = 0;

    // timer for the axios call
    function timeUntilPull() {
        seconds++; 
        if (seconds === self.messageRate) {
            self.callAxios()
            seconds = 0  //reset timer        
        }
      }
      setInterval(timeUntilPull, 1000); 
    },

    async callAxios(){

      let self = this

      try {
      const res = await axios.get('https://bilder.nachtschicht-schortens.de/app/api-messages/json');
      console.log('Pulled Axios Data')

      var AxiosData = res.data.data

      for(let y = 0; y < AxiosData.length; y++){
        AxiosData[y].positionLeft = null
        AxiosData[y].lastItem = false
        let arr =  Array()
        arr = AxiosData[y].created_at.split(" ", 2);
        let newDate = arr[1]
        let nextDate = newDate.slice(0, 5);
        AxiosData[y].created_at = nextDate

      }

      self.showcase = AxiosData // the showcase array is used for checking the data integrity

      if(self.posts.length == 0){
        // dummys should be hidden and are neccessary for the animation to look good
        // this way the posts will be initially stacked from bottom to top
        self.posts.push({ id: 'dummyx', message: 'dummy', dummy: true, positionLeft: false})

        console.log('length was 0')
      }

      self.checkData() //check the id's of the posts

      
      } catch (error) {
        console.error(error);
        }
    },

    checkData(){

      //checking if there are duplicate ids 
      console.log('checking data...')

      for( let i = 0; i < this.showcase.length; i ++){
        let Duplicate = false
        for( let x = 0; x < this.posts.length; x ++){
          if(this.showcase[i].id == this.posts[x].id){
            console.log('Duplikat ' + this.showcase[i].id )
            Duplicate = true
          }
          
        }
        if(Duplicate === false){
          let z = this.posts.length -1
          console.log('post length '+ z)
          if(this.posts[z].positionLeft == true){
            this.showcase[i].positionLeft = false
          }
          if(this.posts[z].positionLeft == false){
            this.showcase[i].positionLeft = true
          }
          console.log('posts length is ' + z)

          if(this.posts[z].lastItem == true){
            this.posts
          }

          this.posts.push(this.showcase[i])
          console.log('element pushed ' + this.showcase[i].id)
        }
        
      }
      console.log(this.posts)
    },
    killPost(){
    // deletes the first item of the array. gets the transition-effect going
    let self = this
    let aSeconds = 0;

    function timeToDie() {
    // timer of the post-deletion
        aSeconds++;
        if (aSeconds === self.messageRate) {
            self.deleteItem()
            aSeconds = 0        
        }
    }
    setInterval(timeToDie, 1000);
    },
    deleteItem(){
      this.posts.splice(0, 1)
    },
  }
}

</script>

<style>

@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap');

#app {
  font-family: 'Roboto', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: black;
  margin-top: 60px;
}

body {
  overflow: hidden;
  margin: 0;
}

li{
  width: 100%;
  display: flex;
  position: relative;
  justify-content: center;
}

.firstElement{
  margin: 0;
}
h2{
  margin: 0;
  font-size: 1.5rem;
  font-weight: 400;
  margin-top: 10px;
  margin-bottom: 10px;
}
.username{
  width: fit-content;
  padding: .5rem 2rem;
  font-size: 1.5rem;
  margin-top: -3rem;
  background-color: #DE03D6;
  border-radius: .75rem;
  box-shadow: 0px 8px 12px 0px rgba(0,0,0,0.1);
  font-weight: 500;
}

.video{
  position: fixed;
  bottom: 0;
  object-fit: cover;
  z-index: -5;
  height: 100vh;
  width: 100vw;

}

.show p {
 font-size: 1.5rem;
}

.postTime{
  margin-top: 20px;
  color: rgb(179, 179, 179); 
  float: right;
  font-weight: 700;
  margin-bottom: 0;
}

.spacer{
  height: 25px;
}

.text-bubble {
  -moz-box-shadow: -1px 44px 42px -30px rgba(0,0,0,0.53);
  -webkit-box-shadow: -1px 44px 42px -30px rgba(0,0,0,0.53);
  background-color:#6633cbb0;
  border-radius: 1.5rem;
  box-shadow: -1px 44px 42px -30px rgba(0,0,0,0.253);
  color:black;
  list-style: none;
  margin-bottom: 3rem;
  padding: 2rem;color:white;
  position: relative;
  width: 50vw;
}

.bubbleanim{
  position: fixed;
  bottom:0;
  right: 0;
  width: 100%;
  margin-bottom: -2rem;

}

.userleft{
  position:absolute;
  bottom: 0;
  text-align: right;
  color: white;
  background-color:rgb(128, 0, 173);
  padding: 0.5rem 2rem;
  border-radius: 4rem;
  -webkit-box-shadow: 0px 15px 60px 0px rgba(0,0,0,0.8);
  -moz-box-shadow: 0px 15px 60px 0px rgba(0,0,0,0.8);
  box-shadow: 0px 15px 60px 0px rgba(0,0,0,0.8);
  font-weight: 500;
}

.userright{
  text-align: left;
  color: white;
  background-color: #DE03D6 ;
  padding: 0.5rem 2rem;
  border-radius: 4rem;
  -webkit-box-shadow: 0px 15px 60px 0px rgba(0,0,0,0.8);
  -moz-box-shadow: 0px 15px 60px 0px rgba(0,0,0,0.8);
  box-shadow: 0px 15px 60px 0px rgba(0,0,0,0.8);
  font-weight: 500;
}

.username-bubble{
  text-align: left;
  color: white;
  background-color: #DE03D6 ;
  padding: 0.35rem 3rem;
  border-radius: 1rem;
  -webkit-box-shadow: 0px 15px 630px 0px rgba(0,0,0,0.2);
  -moz-box-shadow: 0px 15px 30px 0px rgba(0,0,0,0.2);
  box-shadow: 0px 15px 30px 0px rgba(0,0,0,0.2);
  height: fit-content;
  width: fit-content;
}

.user-bubble-left{
  background-color: #6633CB;
}


.bubbleanim li:last-child {
  position: relative;
  bottom: 0;
  /* border: 1px solid lime; */
  animation: slideUp 2s;
}

.bubbleanim li:last-child .show{
  /* animation: shadow 2s; */
   -webkit-box-shadow: 0px 44px 82px 20px rgba(0,0,0,0.64);
  
}

@keyframes shadow {
  0%{
     -webkit-box-shadow: 0px 80px 82px 600px rgba(0,0,0,0.64);
  
  }
  60%{
    -webkit-box-shadow: 0px 80px 82px 20px rgba(0,0,0,0.64);
  }
  100%{
   -webkit-box-shadow: 0px 44px 82px 20px rgba(0,0,0,0.64);
  }
}

.bubbleanim li:last-child .show h2{
 
 animation: slideFadeIn 1s;
 animation-duration: 2s;

}

/* .bubbleanim li:last-child .show .postTime{
 
 animation: slideFadeIn 0.9s;
 animation-duration: 1s;
} */


@keyframes slideUp {
  0% {
    max-height:0px;
    opacity: 0;
    transform: scale(1.05);
   
  /* clip-path: inset(100% 0 0 0); */
  /* clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0% 100%); */
  /* transform: scaleY(0) */
  }
  60%{
    transform: scale(1.05);
  }
  100% {
    max-height:1200px;
    opacity:1; 
    transform: scale(1);
  /* clip-path: inset(0 0 0 0); */
  /* clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%); */
  /* transform: scaleY(1) */

  }
}

@keyframes slideFadeIn {
  0% {
    opacity: 0; transform: translateY(150px);
  /* clip-path: inset(100% 0 0 0); */
  /* clip-path: polygon(0 100%, 100% 100%, 100% 100%, 0% 100%); */
  /* transform: scaleY(0) */
  }
  100% {
    opacity:1;transform: translateY(0px);
  /* clip-path: inset(0 0 0 0); */
  /* clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%); */
  /* transform: scaleY(1) */

  }
}

.img-overlay{
  height: 100vh;
  width: 100vw;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  bottom: 0;
}


.logo {
  position: absolute;
  z-index: 0;
  top: 1rem;
  left: 0;
  width: 20vw;
  opacity: 1;

}

.invisible {
  opacity: 0 !important;
  height: 10rem;
}

.left {
  /*background-color: #a2ebc4;*/
	background-color: #de03d798 ;
	color:white;
}


.spike {
  position: absolute;
  bottom: 0px;
  width: fit-content;
  height: 9rem;
  fill:rgb(240, 200, 255);
  transform: scale(-1, 1)
}

.spike-left{
  left: -80px;
}
.spike-right{
  right: -80px !important;
}

.spikecolor {
  fill: rgb(148, 148, 148);
  transform: scale(1)
}

.qr-code-wrapper{
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  padding: 1rem 1rem;
  background-color: rgba(0,0,0,0.5);
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 15%;

}
.qr-code{
  width: 100%;
  margin: 0 auto;
}
.white{
  color: white;
}


</style>
